import CandidateDocuments from "../CandidateDocuments";



export default function(){

    return (<>
    <div className="card">
    <CandidateDocuments header={"Documents"}/>
    </div>
    </>)
}